module.exports = __webpack_public_path__ + "static/media/home3.442d19cf.jpg";